import type { SVGProps } from "react"

export function LandingLogotye(props: SVGProps<SVGSVGElement>) {
  // Generate unique IDs for this instance
  const clipPathId = `bracket-logotype-clip-${Math.random().toString(36).substr(2, 9)}`
  const pathData =
    "M280.72 -0.00171875L254.55 24.6583L261.33 -0.00171875H243.11L225.1 65.3883L225.07 65.4983H243.28L250.02 40.9483L264.63 65.4583L264.65 65.4983H328.74L332.63 51.3583H303.17L306.46 39.4383H331.65L335.3 26.1483L335.33 26.0383H310.14L313.39 14.1283H353.41L339.29 65.3783L339.26 65.4883H357.46L371.64 14.1283H388.85L392.75 -0.00171875H280.72ZM266.68 34.1983L297.46 5.96828L282.67 59.6483L266.68 34.1983ZM171.35 -0.00171875H147.35L112.89 56.6183L108.6 39.2883C112.21 37.8683 115.69 35.5183 118.41 32.6383C121.82 29.0483 123.93 24.8483 124.68 20.1783C125.51 15.0383 124.32 10.2683 121.33 6.75828C117.56 2.32828 111.11 -0.0117188 102.68 -0.0117188H76.03L58.02 65.3783L57.99 65.4883H76.19L82.42 42.9083H91.66L96.43 65.4283V65.4983H126.13L133.88 52.4483H157.09L157.69 65.4183V65.4983H176.08L171.35 0.0782812V-0.00171875ZM156.51 38.7383H141.75L155.49 14.8383L156.51 38.7383ZM105.98 19.9583C105.88 24.4183 102.46 28.9283 96.1 28.9283H86.4L90.48 14.1583H100.31C102.08 14.1583 103.48 14.6783 104.49 15.6983C105.49 16.7283 106.03 18.2283 105.99 19.9483L105.98 19.9583ZM51.38 32.3983C55.13 31.6983 58.61 29.5783 61.23 26.3983C63.91 23.1383 65.44 19.0683 65.53 14.9283C65.62 10.8383 64.34 7.33828 61.84 4.77828C58.78 1.64828 54 -0.00171875 48.02 -0.00171875H9.79L5.9 14.0283L5.87 14.1383H14.15L0 65.4983H34.19C41.2 65.4983 47.64 63.3583 52.33 59.4583C56.94 55.6283 59.55 50.3783 59.67 44.6983C59.8 38.5183 56.86 34.1583 51.38 32.3983ZM42.33 44.3183C42.24 48.6383 38.66 51.8883 34 51.8883H21.5L25.01 39.1783H37.69C39 39.1783 40.13 39.6283 40.97 40.4883C41.88 41.4183 42.37 42.7783 42.34 44.3183H42.33ZM28.66 25.9483L32.12 13.4183H42.69C44.19 13.4183 45.44 13.8983 46.32 14.7983C47.2 15.6983 47.65 16.9683 47.62 18.4683C47.53 22.7283 43.91 25.9483 39.2 25.9483H28.66ZM225.73 50.6283L221.64 65.4983H203.67C200.45 65.4983 189.41 64.8483 182.62 56.4983C177.6 50.3183 176.23 41.5683 178.56 30.4883C181.29 17.4583 186.24 8.88828 193.69 4.27828C200.1 0.328282 207.3 -0.00171875 213.54 -0.00171875H239.65L235.56 14.8683H215.38C205.42 14.8683 200.82 18.9683 197.81 30.5383C195.74 38.5083 195.94 43.9483 198.43 47.1683C200.21 49.4683 203.23 50.6383 207.43 50.6383H225.73V50.6283Z"

  function handleScrollToTop() {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }

  return (
    <button
      type="button"
      className="relative z-50 cursor-pointer p-0 border-none bg-transparent"
      style={{ width: "393px", height: "66px" }}
      onClick={handleScrollToTop}
    >
      {/* Backdrop blur layer clipped to the text shape */}
      <div
        className="absolute inset-0 backdrop-blur-xs bg-white/10"
        style={{
          clipPath: `path('${pathData}')`,
          WebkitClipPath: `path('${pathData}')`,
        }}
      />

      {/* SVG with transparent fill to show the backdrop blur behind */}
      <svg
        width="393"
        height="66"
        viewBox="0 0 393 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Bracket logotype"
        className="relative z-10"
        {...props}
      >
        <title>Bracket logotype</title>
        <g clipPath={`url(#${clipPathId})`}>
          <path d={pathData} fill="white" fillOpacity="0.8" />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect width="392.75" height="65.5" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </button>
  )
}
